import React from 'react';
import ModalBackdrop from './ModalBackdrop';

function ProfileForm({
  profile,
  setProfile,
  handleSave,
  loading,
  showPrivacyPopup,
  setShowPrivacyPopup,
  initialDataLoaded,
  handleDeleteAccount,
  showDeleteAccountConfirm,
  setShowDeleteAccountConfirm,
  confirmDeleteAccount,
}) {
  return (
    <div className="account-info">
      <h3>Your Information</h3>
      {!initialDataLoaded ? (
        <p className="loading">Loading...</p>
      ) : (
        <form onSubmit={handleSave}>
          <label>
            Display Name (required):
            <input
              type="text"
              value={profile.displayName}
              onChange={(e) => setProfile({ ...profile, displayName: e.target.value })}
              placeholder="Enter display name"
              required
            />
          </label>
          <label>
            First Name:
            <input
              type="text"
              value={profile.firstName}
              onChange={(e) => setProfile({ ...profile, firstName: e.target.value })}
              placeholder="Enter first name"
            />
          </label>
          <label>
            Last Name:
            <input
              type="text"
              value={profile.lastName}
              onChange={(e) => setProfile({ ...profile, lastName: e.target.value })}
              placeholder="Enter last name"
            />
          </label>
          <label>
            Email:
            <input
              type="email"
              value={profile.email}
              disabled
            />
          </label>
          <label>
            Phone Number:
            <input
              type="tel"
              value={profile.phoneNumber}
              onChange={(e) => setProfile({ ...profile, phoneNumber: e.target.value })}
              placeholder="Enter phone number"
            />
          </label>
          <label>
            Height (in):
            <input
              type="number"
              value={profile.height}
              onChange={(e) => setProfile({ ...profile, height: e.target.value })}
              placeholder="Enter height"
            />
          </label>
          <label>
            Body Fat %:
            <input
              type="number"
              step="0.1"
              min="1"
              max="60"
              value={profile.bodyFatPercentage}
              onChange={(e) => setProfile({ ...profile, bodyFatPercentage: e.target.value })}
              placeholder="Optional"
            />
          </label>
          <label>
            Date of Birth:
            <input
              type="date"
              value={profile.dateOfBirth}
              onChange={(e) => setProfile({ ...profile, dateOfBirth: e.target.value })}
            />
          </label>
          <label>
            Gender:
            <select
              value={profile.gender}
              onChange={(e) => setProfile({ ...profile, gender: e.target.value })}
            >
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
          </label>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '6px', margin: '4px 0', width: '100%' }}>
            <input
              type="checkbox"
              id="hideExerciseInfo"
              checked={profile.hideExerciseInfo}
              onChange={(e) => setProfile({ ...profile, hideExerciseInfo: e.target.checked })}
              style={{ width: 'auto', margin: 0, cursor: 'pointer', flexShrink: 0 }}
            />
            <label htmlFor="hideExerciseInfo" style={{ margin: 0, cursor: 'pointer', fontSize: '16px', color: '#f1f5f9', whiteSpace: 'nowrap' }}>
              Hide exercise info
            </label>
            <span className="privacy-info-trigger" onClick={() => setShowPrivacyPopup(true)} style={{ flexShrink: 0 }}>(?)</span>
          </div>
          <div className="button-group" style={{ display: 'flex', flexDirection: 'column', gap: '15px', alignItems: 'center' }}>
            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Saving...' : 'Save Profile'}
            </button>
            <button
              type="button"
              className="btn-danger"
              onClick={handleDeleteAccount}
              disabled={loading}
            >
              {loading ? 'Deleting...' : 'Delete Account'}
            </button>
          </div>
        </form>
      )}
      {showPrivacyPopup && (
        <ModalBackdrop onClose={() => setShowPrivacyPopup(false)}>
          <div className="popup-content">
            <h4>Hide Exercise Info</h4>
            <p>When enabled, your exercise data will not appear on the Community page. Other users will not be able to see your workouts.</p>
            <div className="button-group">
              <button className="btn-primary" onClick={() => setShowPrivacyPopup(false)}>Got it</button>
            </div>
          </div>
        </ModalBackdrop>
      )}
      {showDeleteAccountConfirm && (
        <ModalBackdrop onClose={() => setShowDeleteAccountConfirm(false)}>
          <div className="popup-content">
            <h3>Delete Account</h3>
            <p>Are you sure you want to delete your account? You will lose all history on this profile. This cannot be undone.</p>
            <div className="button-group">
              <button className="btn-danger" onClick={confirmDeleteAccount} disabled={loading}>
                {loading ? 'Deleting...' : 'Delete Account'}
              </button>
              <button className="btn-secondary" onClick={() => setShowDeleteAccountConfirm(false)}>
                Cancel
              </button>
            </div>
          </div>
        </ModalBackdrop>
      )}
    </div>
  );
}

export default ProfileForm;
